import { bearlog } from "@sillyscribe95/bear-ui-web";

export function getBaseNotes(num, minus = 0) {
  const fullnot =
    //
    num;
  // num + minus;
  // noteCurr;
  // notesAll && notesAll[notesAll.length + num];

  bearlog.lug("___ fullnot ___", fullnot);

  const chordTrue = Array.isArray(fullnot);
  let baseChord = chordTrue ? fullnot[0] : fullnot;
  baseChord -= minus;
  // const sizePitch = chordTrue ? 59 : 71;
  const baseNotes =
    //
    (baseChord % 12) + 1;
  // baseChord - sizePitch;

  const basePattern = {
    1: 1,
    3: 2,
    5: 3,
    6: 4,
    8: 5,
    10: 6,
    11: 7,
    12: 7,
    13: 8,
  };

  const endo =
    //
    //   baseNotes
    basePattern[baseNotes];

  // 1console
  bearlog.lug("___ getBasNotes ___", {
    //
    //   notesAll,
    //   fullnot,
    //   array,
    //
    num,
    minus,
    baseChord,
    baseNotes,
    endo,
  });

  return endo;
}
